// tslint:disable: no-invalid-template-strings
import { ActionType, createAction } from 'typesafe-actions';
import { IListObjectStore } from '../../_common/type';
import {
    EBFL1RecordCode,
    TBFL1BackendRecord,
    TBFL1HistoryFilters,
} from './@types';

enum EBFL1Constants {
    FEATURE = '@bfl-1',
    // API = '/bfl1',
    API = '/api/marpol/all',
}
enum EBFL1Actions {
    HISTORY_LOAD = '@bfl-1/:history-load',
    
    HISTORY_SET = '@bfl-1/${history}/set',

    GOTO_DASHBOARD = '@bfl1/-->dashboard',
    GOTO_OPERATION_DASHBOARD = '@bfl1/-->operation-dashboard',
    GOTO_SELECTED_OPERATION = '@bfl1/-->selected-operation',
    GOTO_HISTORY = '@bfl1/-->history',

    SET_FILTER = '@bfl1/:set-filter',
}

const bfl1Actions = {
    commands: {
        historyLoad: createAction(
            EBFL1Actions.HISTORY_LOAD,
            (providedFilters: TBFL1HistoryFilters) => ({ providedFilters })
        )(),
    },
    document: {
        historySet: createAction(
            EBFL1Actions.HISTORY_SET,
            (history: IListObjectStore<TBFL1BackendRecord>) => ({ history })
        )(),
        setFilter: createAction(EBFL1Actions.SET_FILTER, (filter: any) => ({
            filter,
        }))(),
    },
    routes: {
        gotoDashboard: createAction(EBFL1Actions.GOTO_DASHBOARD)(),
        gotoOperationDashboard: createAction(
            EBFL1Actions.GOTO_OPERATION_DASHBOARD
        )(),
        gotoSelectedOperation: createAction(
            EBFL1Actions.GOTO_SELECTED_OPERATION,
            (operationCode: EBFL1RecordCode) => ({ operationCode })
        )(),
        gotoHistory: createAction(EBFL1Actions.GOTO_HISTORY)(),
    },
    events: {},
};

export type TBFL1Actions = ActionType<typeof bfl1Actions>;
export default bfl1Actions;
export { EBFL1Constants, EBFL1Actions };
